export default class warningCenter {
    constructor (parent, options) {
        this.system = parent;
        this.db = parent.dbCom;
        this.objName = options.name;
        console.log(this.objName);
    }

    /**
     * 获取报警
     * @method getAllSourceAlarm
     * @param {object} message 报文
     * @return {number} 0失败，1成功
     */
    async getAllSourceAlarm (message) {
        let data = {
            'head': 'dataLayer',
            'message': message,
        };
        return await new Promise((resolve, reject) => {
            this.db.sendMessage(data, async (err, result) => {
                if (err) {
                    console.log(err);
                    resolve(0);
                } else {
                    resolve(result);
                }
            });
        });
    }

    /** 确认点报警
     * @method AckTag
     * @param {string} alarmId 要确定的报警信息id
     * @param {number} nType 要确认的报警类型(0全部报警，1越限报警，2变化率报警，3偏差报警)
     * @return {*} 0失败，1成功
     */
    async AckTag (alarmId, nType) {
        let res = await this.getAllSourceAlarm({
            head: 'makeConfirmSourceAlarm',
            message: {
                head: 'makeConfirm Alarm',
                alarmIds: [alarmId],
            },
        });
        return res;
    }

    /** 确认点报警
     * @method AckTagEx
     * @param {string} alarmId 要确定的报警信息id
     * @param {number} nType 要确认的报警类型(0全部报警，1越限报警，2变化率报警，3偏差报警)
     * @param {string} strOperation 报警处理措施
     * @return {*} 0失败，1成功
     */
    async AckTagEx (alarmId, nType, strOperation) {
        let res = await this.getAllSourceAlarm({
            head: 'makeConfirmSourceAlarm',
            message: {
                head: 'makeConfirm Alarm',
                alarmIds: [alarmId],
                ackName: strOperation,
            },
        });
        return res;
    }

    /** 获取实时报警个数
     * @method GetAlmCount
     * @param {number} nFlag 0:获取所有,1:获取节点下的
     * @param {string} csLongNode 指定节点名
     * @param {number} nAck 0:确认标记,0未确认;1确认
     * @param {number} nLevel 0:报警等级标记,0低级;1高级;2紧急
     * @return {number} 个数
     */
    async GetAlmCount (nFlag, csLongNode, nAck, nLevel) {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarmCount',
            message: {
                nodeName: nFlag ? csLongNode : '',
            },
        });
        let count = 0;
        res.forEach((value, index) => {
            if (value.haveAcked == nAck && value.Level == nLevel) {
                count++;
            }
        });
        return count;
    }

    /**获取指定节点下最新的报警信息
     * @method GetCurAlarm
     * @param {string} csNodeName 指定节点名
     * @return {*} -1,代表没有报警,0,代表报警,1,代表无需确认,2代表已确认,3代表未确认
     */
    async GetCurAlarm (csNodeName) {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
            message: {
                nodeName: csNodeName.replace(/\./g, '\\'),
            },
        });
        console.log(res);
        if (res.length == 0) {
            return -1;
        }
        if (res[0].needAck) {
            return 1;
        }
        if (res[0].haveAcked) {
            return 2;
        } else if (!res[0].haveAcked) {
            return 3;
        }
        return 0;
    }

    /**获取指定节点下最新的报警信息
     * @method GetCurAlarmEx
     * @param {string} csNodeName 指定节点名
     * @param {number} nSelectType 指定返回类型 0,报警点点长名,1报警类型,2报警描述,3报警时间,4报警id
     * @return {string} 0代表没有报警,
     */
    async GetCurAlarmEx (csNodeName, nSelectType) {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
            message: {
                nodeName: csNodeName.replace(/\./g, '\\'),
            },
        });
        if (res.length === 0) {
            return '0';
        }
        let outValue = null;
        switch (nSelectType) {
            case 0:
                outValue = res[0].name;
                break;
            case 1:
                outValue = this.judgeAlarmType(res[0].topic);
                break;
            case 2:
                outValue = res[0].contentStr;
                break;
            case 3:
                outValue = new Date(res[0].startTime).format('yyyy/MM/dd hh:mm:ss');
                break;
            case 4:
                outValue = res[0].alarmId.toString();
                break;
        }
        return outValue;
    }

    /**获取最新的报警信息--时间
     * @method GetNewAlarmTime
     * @return {string}时间
     */
    async GetNewAlarmTime () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return '';
        }
        return new Date(res[res.length - 1].startTime).format('yyyy/MM/dd hh:mm:ss');
    }

    /**获取最新的报警信息--位号
     * @method GetNewAlarmTagName
     * @return {string}位号
     */
    async GetNewAlarmTagName () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return '';
        }
        return res[res.length - 1].name;
    }

    /**获取最新的报警信息--数值
     * @method GetNewAlarmData
     * @return {number}
     */
    async GetNewAlarmData () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return -1;
        }
        return Number(res[res.length - 1].valueStr);
    }

    /**获取最新的报警信息--限值
     * @method GetNewAlarmLimit
     * @return {number}
     */
    async GetNewAlarmLimit () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return -1;
        }
        let contentStr = res[res.length - 1].contentStr;
        let limit = contentStr.slice(contentStr.indexOf(' ') + 1, contentStr.lastIndexOf(' '));
        return Number(limit.slice(limit.indexOf(':') + 1));
    }

    /**获取最新的报警信息--类型
     * @method GetNewAlarmType
     * @return {string}
     */
    async GetNewAlarmType () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        return this.judgeAlarmType(res[res.length - 1].topic);
    }

    /**获取最新的报警信息--级别
     * @method GetNewAlarmPrio
     * @return {number}
     */
    async GetNewAlarmPrio () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return -1;
        }
        return res[res.length - 1].level;
    }

    /**获取最新的报警信息--确认
     * @method GetNewAlarmAck
     * @return {number}
     */
    async GetNewAlarmAck () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return -1;
        }
        return res[res.length - 1].haveAcked;
    }

    /**获取最新的报警信息--操作员
     * @method GetNewAlarmOper
     * @return {number}
     */
    async GetNewAlarmOper () {
        let res = await this.getAllSourceAlarm({
            head: 'getSourceAlarm',
        });
        if (!res.length) {
            return -1;
        }
        return res[res.length - 1].userId;
    }

    /**据长节点名获取节点ID
     * @method GetTreeNodeUnit 长节点名
     * @param {string} csLongNode 长节点名
     * @return {*} 节点ID; 小于0为失败
     */
    async GetTreeNodeUnit (csLongNode) {
        let res = await this.getAllSourceAlarm({
            head: 'getTagIdByLongName',
            message: {
                longNames: [csLongNode.replace(/\./g, '\\')],
            },
        });
        if (res[0] === undefined) {
            return -1;
        }
        return res[0];
    }

    // 判断报警类型
    judgeAlarmType (type) {
        let value = null;
        switch (type) {
            case 1:
                value = '质量戳改变';
                break;
            case 2:
                value = '值改变';
                break;
            case 4:
                value = '越高限';
                break;
            case 8:
                value = '越高高限';
                break;
            case 16:
                value = '越低限';
                break;
            case 32:
                value = '越低低限';
                break;
            case 64:
                value = '变化率报警';
                break;
            case 128:
                value = '偏差报警';
                break;
        }
        return value;
    }

}



// WEBPACK FOOTER //
// ./src/js/backstage/fvWarningCenter/index.js